import { render, staticRenderFns } from "./SettingBase.vue?vue&type=template&id=40c0d2b2&scoped=true&"
import script from "./SettingBase.vue?vue&type=script&lang=js&"
export * from "./SettingBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c0d2b2",
  null
  
)

export default component.exports